import {
  CLEAR_REIMBURSABLE_EXPENSE,
  RESET_REIMBURSABLE_EXPENSES,
  RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP,
  ReimbursableExpensesActions,
  SELECT_REIMBURSABLE_EXPENSE
} from '@Actions/reimbursableExpensesActions';

import { IExpenseModel } from '@Shared/models';

interface IReimbursableExpensesState {
  selectedExpense: IExpenseModel | null;
  loading: boolean;
  lastLoadedTimestamp: Date;
}

export const defaultState: IReimbursableExpensesState = {
  selectedExpense: null,
  loading: false,
  lastLoadedTimestamp: new Date()
};

export function reimbursableExpensesReducer(state = defaultState, action: ReimbursableExpensesActions): IReimbursableExpensesState {
  switch (action.type) {
    case RESET_REIMBURSABLE_EXPENSES_LOADED_TIMESTAMP: {
      return {
        ...state,
        lastLoadedTimestamp: new Date()
      };
    }

    case RESET_REIMBURSABLE_EXPENSES: {
      return { ...defaultState, lastLoadedTimestamp: state.lastLoadedTimestamp };
    }

    case SELECT_REIMBURSABLE_EXPENSE: {
      return { ...state, selectedExpense: action.payload };
    }

    case CLEAR_REIMBURSABLE_EXPENSE: {
      return { ...state, selectedExpense: null };
    }

    default:
      return state;
  }
}
